<template>
  <v-container fluid>
  <span>Sales Groups</span>
    <v-text-field
      ref="searchTextBox"
      v-model="search" outlined clearable
      append-icon="mdi-magnify"
      label="Search"
      @keyup="onSearchKeyUp($event)"
      class="mx-0 mt-4 mb-0 pa-0 pb-0"
    ></v-text-field>
    <v-data-table
      dense
      :headers="headers"
      :items="items"
      item-key="Id"
      display-text="SalesGroupName"
      :search="search"
      class="elevation-1"
      @click:row="onClickRow($event)"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
    <template slot="no-data" v-if="loading == true">Loading data...</template>
    <template slot="no-data" v-if="loading == false">No records found.</template>
    </v-data-table>
    <v-overlay opacity="0" v-if="loading">
      <v-progress-circular
        indeterminate
        color="red"
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-container>
</template>
<style lang="scss">
</style>
<script>
import api from '@/api.js';

export default {
  name: "salesGroups-view",

  props: {
  },

  data: () => ({
    loading: false,
    itemsPerPage: -1,
    items: [],
    headers: [],
    search: null
  }),

  async created() {
    const me = this;
    me.loading = false;
    me.headers = me.createHeaders();
    me.refresh();
  },

  updated() {
    document.title = "Jura Orga App | Sales Groups";
  },

  methods: {
    async refresh() {
      const me = this;
      me.loading = true;
      const res = await api.get(`SalesGroups`);
      me.items = res.data;
      me.loading = false;
    },

    addNew() {
      this.$router.push(`salesGroups/-1`);
    },

    onClickRow(e) {
      this.$router.push(`salesGroups/${e.Id}`);
    },

    createHeaders() {
      const headers = [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "SalesGroupName",
        },
      ];
      return headers;
    },
  },
};
</script>